import { create } from 'zustand';
import type { ToastAction, ToastVariant } from '../components/Shared/Toast';

export interface Toast {
  id: string;
  message: string;
  variant: ToastVariant;
  duration?: number;
  action?: ToastAction;
}

export interface AddToastOptions {
  duration?: number;
  action?: ToastAction;
}

interface ToastState {
  toasts: Toast[];
  addToast: (
    message: string,
    variant?: ToastVariant,
    durationOrOptions?: number | AddToastOptions,
  ) => void;
  removeToast: (id: string) => void;
  clearToasts: () => void;
}

export const useToastStore = create<ToastState>((set) => ({
  toasts: [],

  addToast: (
    message: string,
    variant: ToastVariant = 'info',
    durationOrOptions: number | AddToastOptions = 5000,
  ) => {
    const id = `toast-${Date.now()}-${Math.random()}`;
    const opts: AddToastOptions =
      typeof durationOrOptions === 'number'
        ? { duration: durationOrOptions }
        : durationOrOptions;
    const toast: Toast = {
      id,
      message,
      variant,
      duration: opts.duration ?? 5000,
      action: opts.action,
    };

    set((state) => ({
      toasts: [...state.toasts, toast],
    }));
  },

  removeToast: (id: string) => {
    set((state) => ({
      toasts: state.toasts.filter((toast) => toast.id !== id),
    }));
  },

  clearToasts: () => {
    set({ toasts: [] });
  },
}));

export default useToastStore;
